import React from 'react';
import { Card, Form, Row, Col, Button, Spinner } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { updateSettings } from '../../../../redux/reducers/authSlice';

const BasicInfo = ({ userDetail }) => {
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.auth.loading);

    const personalForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            fullName: userDetail?.fullName || "",
        },
        validationSchema: Yup.object({
            fullName: Yup.string()
                .min(3, "Too short")
                .required("Full name is required"),
        }),
        onSubmit: async (values) => {
            await dispatch(updateSettings(values));
        },
    });

    return (
        <Card className="border-0 shadow-sm rounded-4 p-4 mt-3">
            <h5 className="fw-bold mb-4">Personal Information</h5>
            <Form onSubmit={personalForm.handleSubmit}>
                <Row className="g-3">
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label className="small fw-bold">Full Name <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                name="fullName"
                                onChange={personalForm.handleChange}
                                onBlur={personalForm.handleBlur}
                                value={personalForm.values.fullName}
                                isInvalid={!!personalForm.errors.fullName && personalForm.touched.fullName}
                                className="bg-light border-0 py-2 shadow-none"
                            />
                            <Form.Control.Feedback type="invalid">
                                {personalForm.errors.fullName}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label className="small fw-bold">Email Address <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                value={userDetail?.email || ""}
                                className="bg-light border-0 py-2 shadow-none"
                                disabled
                            />
                            <Form.Text className="text-muted small">Email cannot be changed directly.</Form.Text>
                        </Form.Group>
                    </Col>
                    <Col md={12} className='text-end mt-4'>
                        <Button 
                            type="submit" 
                            variant="primary" 
                            className="rounded-pill px-4 fw-bold" 
                            disabled={loading}
                        >
                            {loading ? <Spinner size="sm" /> : 'Save Changes'}
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
};

export default BasicInfo;
